
import { Routes, Route } from "react-router-dom";

import Login from "./page/login";
import Notfound from "./page/notfound";
import StockOnhand from "./page/stock-onhand";
import Reports from "./page/report";
import LabelManage from "./page/label-manage";

const AppRoutes = () => (
  <Routes>
    {/* <Route path="/" element={<Loading />} /> */}

    <Route path="/" element={<Login />} />
    <Route path="/stock-onhand" element={<StockOnhand />} />
    <Route path="/reports" element={<Reports />} />
    <Route path="/labels" element={<LabelManage />} />
    <Route path="/*" element={<Notfound />} />
  </Routes>
);

export default AppRoutes;
